import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './Badge.css';

// variant: neutral | brand | success | warning | danger | info; size: sm | md
const Badge = forwardRef(function Badge(
  { variant = 'neutral', size = 'md', dot = false, className, children, ...rest },
  ref
) {
  return (
    <span
      {...rest}
      ref={ref}
      className={cx('ui-badge', `ui-badge--${variant}`, `ui-badge--${size}`, className)}
    >
      {dot && <span className="ui-badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
});

export default Badge;
